import { IPostResponseItem, IUserPrivilegeItem } from "../../services/PrivilegesServices-dto";

export const privilegesTableColumns = [
  "Usuario",
  "Código Privilegio",
  "Descripción",
  "Fecha Actualización",
  "Estado",
];

export function formatPrivilegesList(privileges: IPostResponseItem[]): IUserPrivilegeItem[] {
  return privileges.map((privilege: IPostResponseItem) => ({
    code: privilege.privilege.code,
    name: privilege.privilege.name,
    updatedAt: privilege.updatedAt,
    enabled: privilege.enabled,
  }));
}
